var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5V11.625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.08105C17.9906 6.05113 19.1278 7.47691 19.7422 9.14589C20.3565 10.8149 20.4151 12.6377 19.9091 14.3427C19.4032 16.0477 18.3598 17.5435 16.9346 18.6073C15.5093 19.671 13.7785 20.2457 12 20.2457C10.2215 20.2457 8.49069 19.671 7.06543 18.6073C5.64017 17.5435 4.59682 16.0477 4.09088 14.3427C3.58494 12.6377 3.6435 10.8149 4.25784 9.14589C4.87218 7.47691 6.0094 6.05113 7.5 5.08105",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/Power.82458f2d73f340e314606e73c8744100.svg";
export { ForwardRef as ReactComponent };